<template>
  <div class="layout-container">
    <Navigation v-if="loading" />

    <header ref="header">
      <section>
        <div class="search" v-if="searchVisible">
          <input placeholder="搜索服务" v-model="searchText"></input>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
          <div id="result" v-if="resultVisible">
            <div class="warning" ref="tip">
              <i class="el-icon-warning-outline"></i>
              <span>暂无您要搜索的服务</span>
            </div>
            <div class="item" v-for="item in findServiceList" :key="item.employId"
              @click="$router.push(`guide?employId=${item.employId}&hall=${key === '/hall'}`)">
              <span>{{ item.employName }}</span>
            </div>
          </div>
        </div>
      </section>
    </header>

    <main>
      <router-view :key="key"></router-view>
    </main>

    <Footer v-if="loading" />

    <aside v-if="isLogin">
      <a :href="jumpURL + '/systemReminder'" target=" _blank">
        <img src="../assets/bell.svg" alt="" width="40">
        <span>我的消息</span>
      </a>
      <a @click="$router.push(`/collection`)">
        <img src="../assets/star.svg" alt="" width="40">
        <span>我的收藏</span>
      </a>
    </aside>

    <img src="../assets/smartBaby.gif" class="smart" @click="dialogVisible = true" v-if="isLogin">

    <el-dialog :visible.sync="dialogVisible" width="800px" title="AI助手" :close-on-click-modal="false"
      @opened="openDialog">
      <div class="dialogue-wrapper">
        <div class="dialogue" v-if="dialogueList.length">
          <div class="item" v-for="item, index in dialogueList" :key="index" :class="item.role">
            <img src="../assets/smartBaby.gif" v-if="item.role === 'ai'">
            <img :src="userInfo.headUrl ? baseUrl + userInfo.headUrl : require('../assets/avatar.jpg')" v-else>
            <vue-markdown :source="item.text" class="markdown"></vue-markdown>
            <template v-if="item.role === 'ai'">
              <el-tooltip placement="top" effect="light" transition content="重新生成">
                <el-button size="mini" circle type="primary" plain icon="el-icon-refresh"
                  @click="sendQuestion(dialogueList[index - 1].text)"></el-button>
              </el-tooltip>
              <el-tooltip placement="top" effect="light" transition content="复制">
                <el-button size="mini" circle type="primary" plain icon="el-icon-copy-document"
                  @click="handleCopy(item.text)"></el-button>
              </el-tooltip>
            </template>
          </div>
        </div>
        <div class="hello" v-else>
          <img src="../assets/smartBaby.gif" alt="">
          <b>Hello, 欢迎使用明小杉</b>
          <span>我是你的AI助理明小杉，请把你的需求告诉我，我帮你推荐解答</span>
        </div>
      </div>
      <div class="input">
        <el-input type="textarea" v-model="inputValue" :autosize="{ minRows: 2, maxRows: 10 }"
          placeholder="发消息、输入您的问题（Enter发送 / Ctrl+Enter换行）" @keydown.native="handleKeyDown"></el-input>
        <div class="btns">
          <el-button size="mini" round type="primary" plain @click="dialogueList = []"
            v-if="dialogueList.length">开启新对话</el-button>
          <el-button size="mini" round @click="sendQuestion(inputValue)">发送</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getServiceList } from '../views/hall/api'
import * as api from './api'
const { jumpURL } = projectConfig
export default {
  name: 'Layout',
  components: {
    Navigation: () => import('../components/Navigation'),
    Footer: () => import('../components/Footer'),
  },
  data() {
    return {
      jumpURL,
      baseUrl: null,
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      loading: false,
      isLogin: localStorage.getItem('sys_token'),
      userRole: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userDict : null,
      searchText: '',
      resultVisible: false,
      serviceList: [],
      findServiceList: [],
      dialogVisible: false,
      dialogueList: [],
      inputValue: '',
      progressing: false,
      autoScroll: true
    }
  },
  computed: {
    key() {
      return this.$route.path
    },
    searchVisible() {
      return ['/home', '/hall'].includes(this.$route.path)
    }
  },
  watch: {
    searchText(val) {
      this.resultVisible = Boolean(this.searchText.trim())
      if (val) {
        this.findServiceList = []
        this.serviceList.forEach(item => {
          if (item.employName.indexOf(val) !== -1) {
            this.findServiceList.push(item)
          }
        })
        this.$nextTick(() => {
          this.$refs.tip.style.display = this.findServiceList.length ? 'none' : 'flex'
        })
      } else {
        this.findServiceList = []
      }
    },
    key: {
      handler(val) {
        if (val === '/hall' || val === '/home') this.getSearchList()
      },
      immediate: true
    }
  },
  async created() {
    const { data: { settingValue: baseUrl } } = await api.getConfigInfo('minio_baseUrl')
    this.baseUrl = baseUrl
    localStorage.setItem('baseUrl', baseUrl)
    const { data: { settingValue: logo } } = await api.getConfigInfo('system_logo')
    localStorage.setItem('logo', logo)
    const { data: { settingValue: banner } } = await api.getConfigInfo('workOnline_banner')
    this.$refs.header.style.backgroundImage = `url(${encodeURI(`${this.baseUrl}${banner}`)})`
    const { data: { settingValue: loginType } } = await api.getConfigInfo('login_type')
    localStorage.setItem('loginType', loginType)
    if (loginType == 2) {
      const { data: { settingValue: casLoginUrl } } = await api.getConfigInfo('cas_login_url')
      localStorage.setItem('casLoginUrl', casLoginUrl)
    }
    this.loading = true
  },
  methods: {
    async getSearchList() {
      const { data: { employList } } = await getServiceList({
        status: 1,
        roles: this.userRole == 0 ? 2 : this.userRole == 2 ? 1 : this.userRole == 4 ? 3 : ''
      })
      this.serviceList = employList
    },
    sendInfo() {
      this.infoList.push({ text: this.inpVal, img: require('../assets/ai.png') })
      this.inpVal = ''
    },
    jumpUrlMsg() {
      window.open(jumpURL + '/systemReminder', '_blank')
    },
    openDialog() {
      const node = document.querySelector(".dialogue-wrapper")
      node.addEventListener("scroll", () => {
        this.autoScroll = node.scrollTop + node.clientHeight >= node.scrollHeight
      })
    },
    async sendQuestion(val) {
      if (!val.trim()) return this.$message.warning("输入问题不能为空")
      this.inputValue = ''
      this.dialogueList.push({ role: 'user', text: val })
      const node = document.querySelector(".dialogue-wrapper")
      this.$nextTick(() => {
        if (node) node.scrollTop = node.scrollHeight
      })
      const response = await fetch('/api/n8n-app-chat/home/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/event-stream',
          'X-Token': localStorage.getItem('sys_token')
        },
        body: JSON.stringify({ chatInput: val })
      })
      const reader = response.body.getReader()
      const decoder = new TextDecoder('utf-8')
      let buffer = ''
      while (true) {
        const { value, done } = await reader.read()
        if (done) break
        buffer += decoder.decode(value, { stream: true })
        const blocks = buffer.split('\n\n')
        buffer = blocks.pop() || ''
        for (const block of blocks) {
          const lines = block.split(/\r?\n/)
          let eventName = 'message'
          const dataLines = []
          for (const line of lines) {
            if (line.startsWith('event:')) eventName = line.slice(6).trim()
            if (line.startsWith('data:')) dataLines.push(line.slice(5).trim())
          }
          if (!dataLines.length) continue
          const payload = JSON.parse(dataLines.join('\n'))
          if (eventName === "start") {
            this.dialogueList.push({ role: "ai", text: "思考中···" })
            continue
          }
          if (eventName === 'chunk') {
            if (!this.progressing) {
              this.dialogueList[this.dialogueList.length - 1].text = ''
              this.progressing = true
            }
            const delta = payload.data.delta || ''
            for (const char of delta) {
              this.dialogueList[this.dialogueList.length - 1].text += char
              if (this.autoScroll) {
                this.$nextTick(() => {
                  if (node) node.scrollTop = node.scrollHeight
                })
              }
            }
          }
          if (eventName === 'data') {
            console.log('最终结果:', payload.data.data.output)
            this.progressing = false
          }
          if (eventName === 'error') {
            console.error('错误:', payload.data.message)
          }
        }
      }
    },
    handleCopy(val) {
      navigator.clipboard.writeText(val)
      this.$message.success("复制成功")
    },
    handleKeyDown(e) {
      if (e.keyCode === 13) {
        if (e.ctrlKey) {
          // Ctrl+Enter 换行
          this.inputValue += "\n"
        } else {
          // Enter 发送
          e.preventDefault()
          this.sendQuestion(this.inputValue)
        }
      }
    }
  }
}
</script>

<style lang="scss">
:root {
  --inner-width: 70%;
  --nav-height: 70px;

  #service {
    border-radius: 6px;
    border: 1.5px solid #f2f2f2;
    padding: 20px;
    color: #999;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 15px;
    transition: 300ms;
    cursor: pointer;
    overflow: hidden;

    &:hover {
      border-color: var(--mainColor);
      scale: .97;
    }

    p {
      display: flex;
      align-items: center;
      gap: 15px;

      i {
        font-size: 22px;
        color: var(--mainColor);

        &.el-icon-star-on {
          margin-left: auto;
        }
      }

      b {
        font-size: 18px;
        color: #333;
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    div {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      font-size: 14px;
      color: #666;

      b {
        color: #999;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 4px 10px;
        border-radius: 4px;
        font-size: 10px;

        &.type1 {
          color: #3b82f6;
          background: #3b82f615;
        }

        &.type2 {
          color: #10b981;
          background: #10b98115;
        }

        &.type3 {
          color: #f59e0b;
          background: #f59e0b15;
        }
      }
    }
  }
}

body {
  padding: 0 !important;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.layout-container {
  height: 100vh;
  min-width: 100%;

  header {
    height: 300px;
    background-attachment: fixed;
    background-size: 100% 300px;
    background-position: 0 70px;
    background-repeat: no-repeat;

    section {
      width: var(--inner-width);
      height: 100%;
      margin: 70px auto 0;
      position: relative;

      .search {
        position: absolute;
        right: 0;
        bottom: 160px;
        display: flex;
        align-items: center;

        input {
          width: 320px;
          height: 55px;
          padding: 0 50px;
          border-radius: 6px;
          background: rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.5);
          outline: none;
        }

        svg {
          width: 20px;
          color: $mainColor;
          position: absolute;
          left: 20px;
        }

        #result {
          width: 320px;
          background: rgba(255, 255, 255, 0.3);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.5);
          box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.25);
          border-radius: 6px;
          position: absolute;
          top: 60px;
          padding: 20px;
          display: flex;
          flex-direction: column;
          gap: 16px;
          transition: 300ms;

          .warning {
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 6px;
          }

          .item {
            font-size: 16px;
            width: fit-content;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            // color: $titleColor;
            transition: margin 300ms;
            margin-left: -20px;

            &::before {
              font-family: element-icons;
              content: "\e6e9";
              margin-right: 6px;
              opacity: 0;
              transition: 300ms;
            }

            &:hover {
              color: $mainColor;
              font-weight: bold;
              margin-left: 0;

              &::before {
                opacity: 1;
              }
            }
          }
        }
      }
    }
  }

  main {
    background: #f8f9fa;
  }

  aside {
    position: fixed;
    top: 450px;
    right: 30px;
    box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.05);

    a {
      width: 100px;
      aspect-ratio: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      font-size: 14px;
      border-radius: 6px 6px 0 0;
      background: #fff;
      color: #999;
      transition: 300ms;

      &:hover {
        background: $mainColor;
        color: #fff;

        img {
          filter: brightness(100)
        }

        &::before {
          filter: brightness(100)
        }
      }

      &:nth-child(1)::before {
        content: '';
        width: 10px;
        aspect-ratio: 1;
        border-radius: 50%;
        background: $mainColor;
        position: absolute;
        top: 16px;
        right: 35px;
        z-index: 1;
      }

      &:nth-child(2) {
        border-radius: 0 0 6px 6px;
      }
    }
  }

  .smart {
    position: fixed;
    top: 70vh;
    right: 30px;
    cursor: pointer;
    height: 120px;
  }

  ::v-deep.el-dialog {
    border-radius: 20px;
    background: radial-gradient(30.91% 30.76% at 17.7% 3.32%, rgba(129, 140, 255, 0.2) 0%, rgba(129, 140, 255, 0) 100%), radial-gradient(42.4% 42.23% at 95.19% 22.51%, rgba(150, 255, 242, 0.2) 0%, rgba(150, 255, 242, 0) 100%), #FFFFFF;

    &::before {
      content: '';
      position: absolute;
      top: -3px;
      left: -3px;
      width: calc(100% + 6px);
      height: calc(100% + 6px);
      border-radius: 23px;
      background: linear-gradient(var(--direction), #008BFF, #8CFFFA, #D69FFF, #7C88FF);
      z-index: -1;
      animation: bgRotate 10s linear infinite;
    }

    &__header {
      border: none;
    }

    &__body {
      height: 600px;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .dialogue-wrapper {
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 20px;
        overflow: auto;

        .dialogue {
          height: 0;
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 20px;
          padding-right: 10px;

          .item {
            display: flex;
            align-items: flex-start;
            gap: 5px;
            line-height: 1.5;

            &.user {
              place-self: flex-end;
              flex-direction: row-reverse;
              margin-left: 150px;
              gap: 15px;

              img {
                width: 40px;
                border-radius: 50%;
              }

              .markdown {
                background: $mainColor;
                color: #fff;
                position: relative;

                &::before {
                  content: '';
                  width: 8px;
                  aspect-ratio: 1;
                  background: $mainColor;
                  position: absolute;
                  top: 15.5px;
                  right: -3.5px;
                  transform: rotate(45deg);
                }
              }
            }

            &.ai {
              margin-right: 150px;
              position: relative;

              img {
                width: 50px;
              }

              .markdown {
                background: $auxColor;
                color: #fff;

                &::before {
                  content: '';
                  width: 8px;
                  aspect-ratio: 1;
                  background: $auxColor;
                  position: absolute;
                  top: 15.5px;
                  left: 52px;
                  transform: rotate(45deg);
                }
              }

              .el-button {
                position: absolute;
                bottom: -35px;
                left: 55px;
                cursor: pointer;
                border: none;

                &:last-child {
                  left: 80px;
                }
              }
            }

            .markdown {
              padding: 10px;
              border-radius: 12px;

              table {
                border-collapse: collapse;
                width: 100%;
                margin: 10px 0;
              }

              th,
              td {
                border: 1px solid #ffffff80;
                padding: 8px;
                text-align: left;
              }

              ol {
                list-style-type: decimal;
                padding-left: 20px;

                li {
                  list-style-type: decimal;
                }
              }

              ul {
                list-style-type: disc;
                padding-left: 20px;

                li {
                  list-style-type: disc;
                }
              }
            }
          }
        }

        .hello {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 50px;
          position: relative;

          &::before {
            position: absolute;
            top: 65px;
            content: '';
            width: 35px;
            height: 8px;
            border-radius: 50%;
            background: #eee;
            animation: scale ease-out 1000ms infinite alternate;
          }

          @keyframes scale {
            to {
              scale: .5;
            }
          }

          img {
            width: 80px;
          }

          b {
            font-size: 22px;
            margin-bottom: 15px;
          }
        }
      }

      .input {
        width: 100%;
        position: relative;

        &::after {
          display: block;
          content: '';
          position: absolute;
          bottom: 1.5px;
          left: 1%;
          width: 98%;
          height: 50px;
          background: linear-gradient(to bottom, transparent, #fff 10%);
          border-radius: 15px;
        }

        .el-textarea__inner {
          border-radius: 20px;
          padding: 15px 15px 50px;
          resize: none;
          border: 1.5px solid transparent;
          background-clip: padding-box, border-box;
          background-origin: padding-box, border-box;
          background-image:
            linear-gradient(white, white),
            linear-gradient(135deg, #008BFF, #8CFFFA, #D69FFF, #7C88FF);

          &::-webkit-scrollbar {
            display: none;
          }
        }

        .btns {
          width: calc(100% - 20px);
          position: absolute;
          z-index: 99;
          right: 10px;
          bottom: 10px;
          display: flex;

          .el-button {
            border: none;
          }

          .el-button:last-child {
            border: none;
            background: linear-gradient(var(--direction), #e769e3, #05efff);
            animation: bgRotate 5s linear infinite;
            color: #fff;
            margin-left: auto;
          }
        }
      }
    }
  }
}
</style>